<ng-container *ngIf="!!modalMode">
    <ion-header>
        <ion-toolbar color="primary">
            <ion-title *ngIf="!!modalTitle" class="ion-text-uppercase">
                {{ modalTitle }}
            </ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="dismissModal()" i18n>Chiudi</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
</ng-container>

<ion-content id="ballot-content">
    <ng-container *ngIf="!!ballot; then yesballot else noballot"></ng-container>
</ion-content>

<!-- Ballot Runner Template -->
<ng-template #yesballot>
    <ion-grid [ngSwitch]="ballot.type" id="ballot-grid">

        <!-- Ballot Header -->
        <ion-row>
            <ion-col class="ion-align-items-center ion-text-center" size="12">
                <div class="page__heading ion-margin-top">
                    <div class="page__heading-title">
                        <ion-text *ngSwitchCase="'exchange'" i18n>Proposta di scambio</ion-text>
                        <ion-text *ngSwitchCase="'formation'" i18n>Dubbio di formazione</ion-text>
                        <ion-text *ngSwitchCase="'purchase'" i18n>Dubbio di acquisto</ion-text>
                    </div>
                    <div class="page__heading-subtitle">
                        <ion-text *ngSwitchCase="'exchange'" i18n>Chi sceglieresti? VOTA!</ion-text>
                        <ion-text *ngSwitchCase="'formation'" i18n>Chi schiereresti titolare? VOTA!</ion-text>
                        <ion-text *ngSwitchCase="'purchase'" i18n>Chi acquisteresti all'asta del fantacalcio? VOTA!
                        </ion-text>
                    </div>
                </div>
            </ion-col>
        </ion-row>
        <ion-row class="ballot__footer">
            <ion-col  size="12" style="padding: 15px;">
                <b>{{ ballot.creator || 'anonimo' }}</b>
            </ion-col>
        </ion-row>
        <ion-row id="ballot-matrix">
            <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="4" offset="4">
                <ion-text *ngSwitchCase="'exchange'">
                    <b>{{ matrix[0] }} X {{ matrix[0] }}</b>
                </ion-text>
                <ion-text *ngSwitchCase="'formation'">
                    <b>{{ matrix[0] }} <span i18n>SU</span> {{ matrix[1] }}</b>
                </ion-text>
                <ion-text *ngSwitchCase="'purchase'">
                    <b>{{ matrix[0] }} <span i18n>SU</span> {{ matrix[1] }}</b>
                </ion-text>
            </ion-col>
        </ion-row>

        <!-- Ballot Body -->
        <ion-row [ngClass]="{'animate__animated animate__bounceInUp': !!animate}">
            <ion-col size="12">
                <app-tb-exchange *ngSwitchCase="'exchange'" [ballotObservable]="ballotObservable"
                    [matrixObservable]="matrixObservable" [ballotSkippedObservable]="ballotSkippedObservable"
                    [ballotVotedObservable]="ballotVotedObservable" (vote)="exchangeBallotVote($event)">
                </app-tb-exchange>

                <app-tb-formation *ngSwitchCase="'formation'" [ballotObservable]="ballotObservable"
                    [matrixObservable]="matrixObservable" [ballotSkippedObservable]="ballotSkippedObservable"
                    [ballotVotedObservable]="ballotVotedObservable" (vote)="formationBallotVote($event)">
                </app-tb-formation>

                <app-tb-purchase *ngSwitchCase="'purchase'" [ballotObservable]="ballotObservable"
                    [matrixObservable]="matrixObservable" [ballotSkippedObservable]="ballotSkippedObservable"
                    [ballotVotedObservable]="ballotVotedObservable" (vote)="purchaseBallotVote($event)">
                </app-tb-purchase>
            </ion-col>
        </ion-row>

        <!-- Ballot Footer -->
        <!-- <ion-row class="ballot__footer">
            <ion-col class="ion-align-items-center ion-align-self-center ion-text-center" size="6">
                <b><span i18n>Fantallenatore</span>: {{ ballot.creator || 'anonimo' }}</b>
            </ion-col>
            <ion-col *ngIf="!!modalMode===false" class="ion-align-items-center ion-align-self-center ion-text-right" size="6">
                <ion-button [disabled]="skipButtonDisabled" (click)="skipTurboBallot()" id="skip-ballot-button" size="small" color="tertiary" i18n>
                    Salta
                </ion-button>
            </ion-col>
        </ion-row> -->

        <!-- Scroll Expand Trick -->
        <ion-row><ion-col><p>&nbsp;</p><p>&nbsp;</p></ion-col></ion-row>

    </ion-grid>
</ng-template>

<!-- No Ballot Template -->
<ng-template #noballot>
    <ion-grid class="grid-full-screen">
        <ion-row>
            <ion-col size="12">
                <div class="page__heading ion-margin-top">
                    <div class="page__heading-title">
                        <span i18n>Non ci sono ballottaggi da mostrare</span>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</ng-template>